/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControlLabel,
  Link,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUpload';
import AnyButton from '../../components/atoms/AnyButton';
import StepProgressBar from '../../components/atoms/StepProgressBar';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  mt20: {
    marginTop: 20
  },
  font16: {
    fontSize: 16
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  bold: {
    fontWeight: 'bold'
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  description: {
    color: '#707070',
    fontSize: 14
  },
  linkToPrev: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    prefectures: state.commons.prefectures
  })),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withState('btnText', 'setBtnText', '入力画面に戻る'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('registerCopy', 'setRegisterCopy', null),
  withState('previewImageRegisterCopy', 'setPreviewImageRegisterCopy', null),
  withState('registerCopyError', 'setRegisterCopyError', ''),
  withState('note', 'setNote', ''),
  withState('openPopUp3', 'setOpenPopUp3', false),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const Main = enhance(
  ({
    classes,
    show,
    handleRedirect,
    proceedToNext,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolder,
    setBankAccountHolder,
    bankAccountHolderError,
    setBankAccountHolderError,
    registerCopy,
    setRegisterCopy,
    previewImageRegisterCopy,
    setPreviewImageRegisterCopy,
    registerCopyError,
    setRegisterCopyError,
    note,
    setNote,
    openPopUp3,
    setOpenPopUp3,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch
  }) => {
    const shopParams = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };
    const identityParams = {
      registerCopy,
      note
    };
    const errors = {
      bankAccountNumberError,
      bankAccountHolderError,
      registerCopyError,
      bankCodeError,
      bankBranchCodeError
    };

    const validBankAccountNumber = () => {
      const value = bankAccountNumber ? bankAccountNumber.trim() : '';
      if (value === '') {
        setBankAccountNumberError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setBankAccountNumberError('半角数字のみで7桁で入力してください。');
        return 1;
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };

    const validBankAccountHolder = () => {
      const value = bankAccountHolder ? bankAccountHolder.trim() : '';
      if (value === '') {
        setBankAccountHolderError('必須項目です。');
        return 1;
      }
      if (
        !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
          value
        )
      ) {
        setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
        return 1;
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };

    const validRegisterCopy = () => {
      if (!registerCopy) {
        setRegisterCopyError('必須項目です。');
        return 1;
      }
      setRegisterCopyError('');
      return 0;
    };

    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (value === '') {
        setBankCodeError('必須項目です。');
        return 1;
      }
      if (!/^[0-9\b]+$/.test(value)) {
        setBankCodeError('データが正しくありません。');
        return 1;
      }
      if (value.length !== 4) {
        setBankCodeError('データが正しくありません。');
        return 1;
      }
      if (!getBankName(value)) {
        return 1;
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (value === '') {
        setBankBranchCodeError('必須項目です。');
        return 1;
      }
      if (!/^[0-9\b]+$/.test(value)) {
        setBankBranchCodeError('データが正しくありません。');
        return 1;
      }
      if (value.length !== 3) {
        setBankBranchCodeError('データが正しくありません。');
        return 1;
      }
      if (!getBankBranchName(value)) {
        return 1;
      }
      setBankBranchCodeError('');
      return 0;
    };

    const valid = () => {
      const errorCount =
        validBankAccountNumber() +
        validBankAccountHolder() +
        validRegisterCopy() +
        validBankCode() +
        validBankBranchCode();
      return errorCount === 0;
    };

    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };

    return (
      <div className={show ? null : classes.hidden}>
        <div className={classes.page}>
          <div className={classes.titleGroup}>
            <Typography component="h2" variant="h5">
              審査申請情報の入力
            </Typography>
          </div>

          <StepProgressBar currentStep={1} />

          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <Typography variant="body2">
                アカウント登録ありがとうございます。本画面から、店舗の登録審査を行います。必要書類を準備の上、ご提出ください。
                <br />
                <br />
                ①銀行口座情報及び振込先通帳の1枚目画像
                <br />
                <span className={classes.redText}>
                  特定のコードをお持ちの方のみ、以下②~④のご準備は不要です。
                </span>
                <br />
                ②営業許可証
                <br />
                ③印鑑証明書（法人の場合のみ）・身分証明書・公共料金の領収書いずれか
                <br />
                ④法人番号（法人の場合のみ）
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Typography className={`${classes.bold} ${classes.font16}`}>
                ①銀行口座情報及び振込先銀行通帳の1枚目画像
              </Typography>
              <RequiredButton />
              <TextField
                required
                label="銀行コード"
                placeholder="0000"
                fullWidth
                margin="normal"
                onChange={e => {
                  handleChangeBankCode(e.target.value);
                }}
                value={bankCode}
                onBlur={validBankCode}
                inputProps={{
                  maxLength: 4,
                  inputMode: 'numeric'
                }}
              />
              <Typography className={`${classes.font12}`}>
                ※
                <Link
                  href="https://zengin.ajtw.net/"
                  target="_blank"
                  className={classes.link}
                >
                  検索サイト
                </Link>
              </Typography>
              <Typography className={`${classes.font12}`}>
                半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
              </Typography>
              <ValidationText message={errors.bankCodeError} />
              <TextField
                label="銀行名"
                fullWidth
                margin="normal"
                value={bankName}
                disabled
                className={classes.disableInput}
              />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <TextField
                required
                label="支店コード"
                placeholder="000"
                fullWidth
                margin="normal"
                onChange={e => {
                  setBankBranchCode(e.target.value);
                  setBankBranchName('');
                }}
                value={bankBranchCode}
                onBlur={validBankBranchCode}
                inputProps={{
                  maxLength: 3,
                  inputMode: 'numeric'
                }}
              />
              <Typography className={`${classes.font12}`}>
                ※
                <Link
                  href="https://zengin.ajtw.net/"
                  target="_blank"
                  className={classes.link}
                >
                  検索サイト
                </Link>
              </Typography>
              <Typography className={`${classes.font12}`}>
                半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
              </Typography>
              <ValidationText message={errors.bankBranchCodeError} />
              <TextField
                label="支店名"
                fullWidth
                margin="normal"
                disabled
                className={classes.disableInput}
                value={bankBranchName}
              />
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Typography className={classes.description}>口座種別</Typography>
              <RadioGroup
                row
                value={bankAccountType}
                onChange={e => {
                  setBankAccountType(e.target.value);
                }}
              >
                <FormControlLabel
                  value="SAVINGS"
                  control={<Radio color="primary" />}
                  label="普通預金"
                />
                <FormControlLabel
                  value="CHECKING"
                  control={<Radio color="primary" />}
                  label="当座預金"
                />
              </RadioGroup>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <TextField
                required
                label="口座番号"
                placeholder="1234567"
                fullWidth
                margin="normal"
                onChange={e => {
                  setBankAccountNumber(e.target.value);
                }}
                onBlur={validBankAccountNumber}
              />
              <ValidationText message={errors.bankAccountNumberError} />
              <Typography className={classes.font12}>
                半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <TextField
                required
                label="口座名義"
                placeholder="ゴチ　メシコ"
                fullWidth
                margin="normal"
                onChange={e => {
                  setBankAccountHolder(e.target.value);
                }}
                onBlur={validBankAccountHolder}
              />
              <ValidationText message={errors.bankAccountHolderError} />
              <Typography className={classes.font12}>
                カタカナでご記入ください。
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <RequiredButton />
              <Typography
                className={`${classes.bold} ${classes.font16} ${classes.mt20}`}
              >
                振込先銀行通帳の1枚目画像
              </Typography>
              <Typography color="textSecondary" className={classes.font14}>
                <span className={classes.bold}>
                  表紙を開いて振込先の銀行・支店・口座番号・名義人が全て記載されているページ
                </span>
              </Typography>
              <FileUpload
                label="registerCopy"
                setFile={setRegisterCopy}
                previewImage={previewImageRegisterCopy}
                setPreviewImage={setPreviewImageRegisterCopy}
              />
              <ValidationText message={errors.registerCopyError} />
            </div>
            <div className={classes.pagerInDiv}>
              <AnyButton />
              <TextField
                label="連絡欄"
                fullWidth
                margin="normal"
                onChange={e => {
                  setNote(e.target.value);
                }}
              />
              <Typography className={`${classes.font12} ${classes.redText}`}>
                特定のコードをお持ちの場合、こちらに入力ください。
              </Typography>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  if (valid()) {
                    proceedToNext({
                      shopParams,
                      identityParams,
                      hasSpecialCode: note === 'gOCHI'
                    });
                  } else {
                    alert('登録情報を正しく入力してください。');
                  }
                }}
              >
                次に進む
              </Button>
            </div>
          </Paper>
        </div>
        <div className={classes.linkToPrev}>
          <Button
            color="primary"
            onClick={() => {
              handleRedirect('/');
            }}
          >
            ログイン画面に戻る
          </Button>
        </div>

        <Dialog className={classes.dialog} open={openPopUp3}>
          <DialogContent className={classes.dialogContent}>
            <CardMedia
              component="img"
              image="/images/popup3.jpg"
              className={classes.imageInfo}
            />
          </DialogContent>
          <DialogActions>
            <Button
              type="text"
              color="primary"
              onClick={() => setOpenPopUp3(false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
